<template>
  <div class="zp-auth d-flex flex-column" style="padding: 0 !important;">
    <div class="flex-grow-1 d-flex">
      <div class="d-flex align-center justify-center white pa-5" style="max-width: 500px; width: 100%;">
        <div class="d-flex flex-column align-center pl-10 pr-10 text-center" style="max-width: 370px; width: 100%;">
          <h1>Olá!</h1>
          <p>
            Acesse o Gerenciador com uma das contas abaixo
          </p>
          <v-btn color="red darken-1" id="btn-google" large depressed class="mt-5" @click="google()" dark block>
            <v-icon class="mr-1">mdi-google</v-icon> <span>Entrar com o Google</span>
          </v-btn>
          <v-btn color="primary" large class="mt-5" depressed @click="facebook()" :loading="loading.facebook" block>
            <v-icon class="mr-1">mdi-facebook</v-icon> <span>Entrar com o Facebook</span>
          </v-btn>
          <div class="d-flex mt-15 justify-space-between pl-3 pr-3" style="width: 100%;">
          <a target="_blank" class="black--text" style="font-size: .8em; text-decoration: none;" href="https://www.zaper.in/gerenciador-de-links-termos-de-uso">Termos de uso</a>
          <a target="_blank" class="black--text" style="font-size: .8em; text-decoration: none;" href="https://www.zaper.in/gerenciador-de-links-termos-de-uso">Política de privacidade</a>
          </div>
        </div>
      </div>
      <div class="flex-grow-1 d-none d-sm-flex text-center flex-column justify-center align-center pt-15 pb-10" style="background-color: #823EDF; color: white">
        <div class="d-flex flex-column align-center" style="height: 100%; max-width: 500px;">
          <a href="https://www.zaper.in">
            <img src="/img/logo-white.svg" alt="">
          </a>
          <h1 class="mt-10">Dê poder aos seus links.</h1>
          <div class="mt-3">A Zaper foi desenvolvida para resolver sua gestão de links. É simples de usar e pensada para pessoas e empresas que trabalham com campanhas de tráfego pago ou orgânico. <strong>Vem com a gente!</strong></div>
          <div class="mt-5 flex-grow-1">
            <div style="position: relative; cursor: pointer" @click="playVideo = true">
              <img src="/img/browser-app.svg" alt="">
              <img style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%)" src="/img/video-play-button.svg" alt="">
            </div>
          </div>
          <small class="mt-10">Zaper © 2020-2022 - Todos os direitos reservados. </small>
        </div>
      </div>
    </div>

    <v-dialog
      v-if="playVideo"
      v-model="playVideo"
      width="850"
      transition="dialog-bottom-transition"
    >
      <v-card class="pa-12" style="position: relative;">
        <v-btn style="position: absolute; right: 15px; top: 15px;" icon @click="playVideo = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <div class="d-flex justify-center">
          <iframe width="800" height="450" src="https://www.youtube.com/embed/FoQ-NAy9ULs" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data () {
    return {
      loading: {},
      playVideo: false
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user
    })
  },
  methods: {
    setLoading (name, value) {
      this.loading = {
        ...this.loading,
        [name]: value
      }
    },
    async facebook () {
      this.setLoading('facebook', true)
      try {
        const data = await this.$store.dispatch('auth/login', { type: 'facebook', utm_source: this.$route.query.utm_source || '', plan: this.$route.query.plan || '' })
        this.to(data)
      } catch (e) {
        console.error(e)
      }
      this.setLoading('facebook', false)
    },
    async google () {
      this.setLoading('google', true)
      try {
        const data = await this.$store.dispatch('auth/login', { type: 'google', utm_source: this.$route.query.utm_source || '', plan: this.$route.query.plan || '' })
        this.to(data)
      } catch (e) {
        console.error(e)
      }
      this.setLoading('google', false)
    },
    to (data) {
      if (this.$route.query.redirect) {
        this.$router.push(this.$route.query.redirect)
      } else if (data.registered) {
        this.$router.push('/aprender-e-praticar')
      } else {
        this.$router.push('/links')
      }
    }
  },
  mounted () {
    if (this.$route.query.utm_source) {
      localStorage.setItem('utm_source', true)
    }

    if (this.user) {
      this.$router.push('/links')
    }
  }
}
</script>

<style lang="scss" scoped>
.zp-auth {
  color: #000;
  background-color: #fff;
}

.green--text {
  color: #21c59e;
}
</style>